export enum RepliersListingBuildingClass {
  Commercial = 'CommercialProperty',
  Residential = 'ResidentialProperty',
  Condo = 'CondoProperty',
}
